<!--账户退款-->
<template>
  <div class="container page-account-refund bg-white">
    <pi-enterprise-text v-if="userType==3">
      {{accountObj.accountName}}
    </pi-enterprise-text>
    <div class="refund-center container-flex">
    <pi-balance-block :accountObj="accountObj" btnName="退款记录" :titleTips="false" :balanceAmount="false" @btnClick="gotoRecord"></pi-balance-block>

    
      <div class="change-title">退款金额</div>
      <div class="change-box">
        <div class="icon v-center">¥</div>
        <div class="flex">
          <input type="number"
                 :class="{'number':refundMoney > 0 || refundMoney.length > 0}"
                 v-model="refundMoney"
                 placeholder="请输入您要退款的金额">
        </div>
        <div class="icon-all v-center"
             @click="allMoneyClick">
          全部
        </div>
      </div>
      <van-divider :style="{ borderColor: '#dcdcdc', margin: '0 0', padding: '0 0.2rem' }" />
      
      <div class="refund-tips" v-if="oprInfo.refundDescribe">{{oprInfo.refundDescribe}}</div> 
      <div class="refund-tips" v-else-if="!getLoading && !oprInfo.refundDescribe">申请退款后，3-7个工作日完成审核</div> 
    </div>
    <div class="btn-bottom">
      <!-- <div class="refund-text">点击立即申请即表示您已阅读并同意 <router-link class="refund-agreement"
                     to="">《退款协议》</router-link>
      </div> -->
      <pi-button @click="onRefundClick" type="primary" v-if="oprInfo.hasOpenRefund || oprInfo.hasOpenRefund == null"
                 block>申请退款</pi-button>
    </div>
  </div>
</template>

<script>
import { Image, Cell, CellGroup, Divider } from "vant";
import {
  customRefund,
  getAccount,
  getEntAccount,
  getNotPayOrder,
  getOprCongifInfo
} from "../../common/api";
import enterpriseText from "@/components/pi-enterprise-text/pi-enterprise-text";
import balanceBlock from "@/components/pi-balance-block/pi-balance-block.vue";
export default {
  name: "about",
  components: {
    [Image.name]: Image,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Divider.name]: Divider,
    [enterpriseText.name]: enterpriseText,
    [balanceBlock.name]: balanceBlock
  },
  data() {
    return {
      myMoney: 0,
      refundMoney: "",
      userType: 1,
      accountObj: {},
      orders: [],
      oprInfo: {},
      getLoading: false
    };
  },
  mounted() {
    this.accountPkId = this.$route.query.accountPkId;
    this.userType = this.$route.query.userType;
    if (this.userType == 3) {
      this.getEntAccount();
    } else {
      this.getMoney();
    }
    this.getOprCongifInfo();
  },
  methods: {
    async getOprCongifInfo(){
      this.getLoading = true;
      let ret = await getOprCongifInfo({});
      if (
          ret.status === this.$config.ajaxStatus &&
          ret.data.length > 0
        ) {
          this.oprInfo = ret.data[0];
        }
        this.getLoading = false;
    },
    getNotPayOrder() {
      getNotPayOrder(null, false).then(data => {
        if (
          data.status === this.$config.ajaxStatus &&
          data.data &&
          data.data.length > 0
        ) {
          this.orders = data.data;
        }
      });
    },
    getEntAccount() {
      getEntAccount().then(response => {
        if (
          response.status === this.$config.ajaxStatus &&
          response.data.length > 0
        ) {
          var accountObj = response.data[0];
          this.accountObj = accountObj;
          this.myMoney = accountObj.availableAmount;
          this.accountPkId = accountObj.accountPkId;
          // this.getMoney();
        } else {
          this.myMoney = "-";
        }
      });
    },
    gotoRecord() {
      this.$router.push({
        name: "record",
        query: {
          accountPkId: this.accountPkId,
          orderType: 2
        }
      });
    },
    getMoney() {
      getAccount(
        {
          accountPkId: this.accountPkId
        },
        true
      )
        .then(data => {
          if (data.status === this.$config.ajaxStatus && data.data[0]) {
            this.accountObj = data.data[0];
            this.myMoney = data.data[0].availableAmount;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    allMoneyClick(){
      this.refundMoney = this.myMoney + 0;
    },
    onRefundClick() {
      // if(this.orders.length > 0){
      //   this.$toast("您存在未完成订单，请完成后再退款");
      //   return;
      // }
      if (this.$common.isEmpty(this.refundMoney)) {
        this.$toast("退款金额不能为空");
        return;
      }

      if (this.refundMoney > this.myMoney) {
        this.$toast("退款金额不能大于余额");
        return;
      }

      this.$dialog
        .confirm({
          title: "是否确认提交退款申请？",
          message:
            "提交后退款金额将会原路返回到您的微信账户，您可以在退款记录查看退款信息。",
          confirmButtonText: "是",
          confirmButtonColor: "#14CC80",
          cancelButtonText: "否",
          cancelButtonColor: "#999999",
          closeOnPopstate: true
        })
        .then(() => {
          //confirm dialog
          customRefund({
            accountPkId: this.$route.query.accountPkId,
            refundAmount: this.refundMoney
          })
            .then(data => {
              if (data.status === this.$config.ajaxStatus) {

                this.$dialog
                  .alert({
                    title: "申请退款成功",
                    confirmButtonText: "关闭",
                    confirmButtonColor: "#999999",
                    closeOnPopstate: true
                  })
                  .then(() => {
                    this.$router.go(-1);
                  })
                  .catch(() => {});
              } else {
                throw new Error(data.msg);
              }
            })
            .catch(error => {
              console.log(error);
              if (!this.$common.isEmpty(error.message)) {
                this.$toast(error.message);
              } else {
                this.$toast("退款失败");
              }
            });
        })
        .catch(() => {
          //close dialog
        });
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/less/old/var.less";

.page-account-refund {
  
  .enterprise {
    background: rgba(255, 210, 152, 0.25);
    color: #666666;
    font-size: 0.24rem;
    line-height: 0.33rem;
    padding: 0.08rem;
    text-align: center;
  }
  // .wallet-box{
  //   margin: 0.2rem 0.2rem 0 0.2rem;
  //   background: linear-gradient(90deg, #FF9A37 0%, #FFCA24 100%);
  //   border-radius: 0.10rem;
  // }
  // .wallet {
  //   width: 100%;
  //   height: 2.72rem;
  //   background: url("../../assets/img/bg_cash_top.png");
  //   background-size: 100%;
    
  //   box-shadow: 0px 0px 0.23rem -0.02rem rgba(255, 154, 55, 0.2);
  //   border-radius: 0.10rem;
  //   position: relative;
  //   color:#fff;
  //   padding: 0.2rem;
  //   box-sizing: border-box;
  //   .wallet-title {
  //     font-size: 0.3rem;
  //     font-weight: 400;
  //     line-height: 0.42rem;
  //   }

  //   .wallet-money {
  //     font-size: 0.90rem;
  //     font-weight: 500;
  //     line-height: 1.26rem;
  //     margin-top: 0.1rem;
  //   }
  //   .other-money-box{
  //     display: flex;
  //     margin-top: 10rpx;
  //     font-size: 30rpx;
  //     line-height: 42rpx;
  //   }
  //   .other-money-flex{
  //     flex: 1;
  //   }
  //   .other-money-flex:last-child{
  //     text-align: right;
  //   }
  //   .recharge-record {
  //     padding: 0.06rem 0.21rem;
  //     background-color: #fff;
  //     border-radius: 0.28rem;
  //     font-size: 0.30rem;
  //     font-weight: 400;
  //     color: #FF9A37;
  //     line-height: 0.42rem;
  //     position: absolute;
  //     right: 0.20rem;
  //     top: 0.20rem;
  //   }
  // }
  .refund-center {
    padding: 0.2rem;
  }
  .refund-text {
    color: #999999;
    font-size: 0.18rem;
    line-height: 0.38rem;
    text-align: center;
    margin-bottom: 0.2rem;
    .refund-agreement {
      color: #576b95;
    }
  }
  .change-title {
    font-size: 0.34rem;
    line-height: 0.48rem;
    color: #666666;
    margin-top: 0.2rem;
  }
  .change-box {
    display: flex;
    margin-top: 0.2rem;
    border-bottom: @border;
    .icon-all{
      font-size: 0.3rem;
      line-height: 0.7rem;
      color: @main-color;
    }
    .icon {
      font-size: 0.5rem;
      line-height: 0.7rem;
      color: @black;
      img {
        width: 0.44rem;
        margin-top: 0.18rem;
        vertical-align: top;
      }
    }
    .flex {
      flex: 1;
      padding-left: 0.1rem;
      padding-top: 0.03rem;
      input {
        font-size: 0.32rem;
        line-height: 0.84rem;
        font-weight: bold;
        width: 100%;
      }
      input.number {
        font-size: 0.6rem;
      }
    }
  }
  .sub-change {
    .tips-text {
      color: #999;
      margin-bottom: 0.2rem;
      text-align: center;
      .mini-size;
      a {
        color: @blue;
      }
    }
    .sq-refund {
      text-align: center;
      margin-top: 0.2rem;
      .size;
      color: @main-color;
    }
  }
  .btn-bottom {
    padding: 0.4rem;
  }
  .wen{
    width: 0.34rem;
    height: 0.34rem;
    vertical-align: text-bottom;
    margin-left: 0.05rem;
  }
  .refund-tips{
    margin-top: 0.4rem;
    font-size: 0.32rem;
    line-height: 0.42rem;
    color: #FF9A37;
    text-align: center;
  }
}
</style>
